const PAGE_SIZE = 200;

export default function getRowRangePageSize(startIndex, stopIndex) {
  let page;
  let pageSize;

  if (startIndex === stopIndex) {
    page = startIndex;
    pageSize = 1;
  } else if (stopIndex >= startIndex + PAGE_SIZE) {
    page = Math.floor(startIndex / PAGE_SIZE) + 1;
    pageSize = PAGE_SIZE;
  } else {
    for (let i = stopIndex - startIndex + 1; i <= PAGE_SIZE; i++) {
      if (
        Math.floor(startIndex / i) === Math.floor(stopIndex / i) ||
        i === PAGE_SIZE
      ) {
        page = Math.floor(startIndex / i) + 1;
        pageSize = i;
        break;
      }
    }
  }

  return {
    page,
    pageSize,
    firstIndex: (page - 1) * pageSize,
  };
}
